import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Select$ } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlayerGuard implements CanActivate {
  @Select$(['remote', 'id'], obs$ => obs$.pipe(map(Boolean))) hasRemote$: Observable<boolean>;

  constructor(private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.hasRemote$.pipe(
      tap(hasRemote => !hasRemote && this.router.navigate(['/zones'])),
    );
  }

}
